import { render } from "./Momenten.vue?vue&type=template&id=5afaef5c"
import script from "./Momenten.vue?vue&type=script&lang=js"
export * from "./Momenten.vue?vue&type=script&lang=js"

import "./Momenten.vue?vue&type=style&index=0&id=5afaef5c&lang=css"

import exportComponent from "/Users/vincent/Documents/GIT_CLONES/skipiste/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__